var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhutan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 10,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3457 9497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H40L0,24V0Z",
    transform: "translate(-3457 -9497)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40-12V12H0Z",
    transform: "translate(-3457 -9485)",
    fill: "#ed5200"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4395.694 -3122.64) rotate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5693.649-9510.649h5.007a4,4,0,0,1,4-4,4,4,0,0,1,4,4h-5.007a4,4,0,0,1-4,4A4,4,0,0,1-5693.649-9510.649Zm-9.993,0h8a4,4,0,0,1-4,4A4,4,0,0,1-5703.643-9510.649Zm5,0a4,4,0,0,1,4-4,4,4,0,0,1,4,4Z",
    transform: "translate(2254.643 22.648)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3541.218-8606h-5.49l-14.51,24h20Z",
    transform: "translate(124.218 -891)",
    opacity: 0.095
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhutan);
export default __webpack_public_path__ + "static/media/BHUTAN.747f11741e015bbd698c7b3c0fcb9f8b.svg";
export { ForwardRef as ReactComponent };